export * from './font-size'
export * from './font-weight'
export * from './letter-spacing'
export * from './line-clamp'
export * from './line-height'
export * from './text-align'
export * from './text-decoration'
export * from './text-indent'
export * from './text-overflow'
export * from './text-transform'
export * from './text-wrap'
export * from './vertical-align'
export * from './white-space'
